import * as React from "react";
import {Box, Divider, Stack, Typography, useMediaQuery, useTheme} from "@mui/material";
import {Address, SocialLinks} from "../components/Contact";
import ImageCard from "../components/ImageCard";
import {Translation} from "../components/Translation";
import {sponsors_list} from "../data/Sponsors";
import {useIsXs} from "../hooks/UseDimensionHooks";
import {Carousel} from "../components/Carousel";
import Layout from "./Layout";

function Sponsor(props: { image: string }) {
    return <Stack
        gap='15px'
        sx={{
            maxWidth: {
                xs: "210px",
                sm: "initial",
            },
            width: {
                xs: 'initial',
                sm: '100%',
            },
            alignItems: 'center',
        }}>
        <ImageCard sx={{
            objectFit: 'contain',
            height: '100px',
        }} src={props.image}/>
    </Stack>;
}

function Sponsors() {
    const isXs = useIsXs();
    return <Box sx={{
        display: "flex",
        justifyContent: {
            xs: 'center',
            sm: 'initial',
        }
    }}>
        <Box sx={{
            pt: {
                xs: 2,
                sm: 0,
            },
            maxWidth: {
                xs: '100%',
                sm: '100%',
            },
        }}>
            <Box sx={{
                pb: {
                    xs: 2,
                    sm: 1,
                },
            }}>
                <Translation variant="cardTitle" pl={"Sponsorzy i partnerzy"} en={"Sponsors and partners"}/>
            </Box>
            <Carousel
                autoPlay={true}
                hideButtons={true}
                autoPlayInterval={1500}
                space={isXs ? 25 : 50}
                numberOfSlides={{
                    xs: 1,
                    sm: 2,
                    md: 3,
                    lg: 4,
                    xl: 5,
                }}
            >
                {sponsors_list.map((sponsor_list) =>
                    sponsor_list.sponsors.map((sponsor) => <Sponsor
                        image={sponsor.image}
                    />))
                    .flat()}
            </Carousel>
        </Box>
    </Box>;
}

function Logo() {
    const theme = useTheme();
    const underSm = useMediaQuery(theme.breakpoints.down('sm'));
    const overXl = useMediaQuery(theme.breakpoints.up('lg'));
    if (!(overXl || underSm)) {
        return <></>
    }
    return <Box sx={{
        pt: 2,
    }}>
        <ImageCard
            image={"/static/logo/black_text_bottom.png"}
            sx={{
                height: '125px',
                objectFit: "contain",
            }}
        />
    </Box>;
}

function FooterDivider() {
    return <Box sx={{
        mb: 2,
    }}>
        <Divider variant="fullWidth"/>
    </Box>;
}

function Copyright() {
    return <Box sx={{
        pt: 2,
        pb: 2,
    }}>
        <Typography variant="body2">
            Copyright © 2026 International Conference – ARCHITECTURE OF CHALLENGES – EXPERIMENT IN SPACE – THE SPACE OF EXPERIMENT. All rights reserved.
        </Typography>
    </Box>;
}

function Footer() {
    const theme = useTheme();
    const dark_mode = theme.palette.mode === "dark";
    const underSm = useMediaQuery(theme.breakpoints.down('sm'));
    return (
        <Box sx={{
            mt: 10,
            color: dark_mode ? theme.palette.primary.contrastText : "initial",
            backgroundColor: dark_mode ? theme.palette.primary.main : "initial",
        }}>
            <Layout>
                <FooterDivider/>
                <Stack
                    justifyContent={underSm ? "flex-start" : "space-between"}
                    alignItems={underSm ? "center" : "initial"}
                    gap={underSm ? 5 : 0}
                    direction={underSm ? "column" : "row"}>
                    <Logo/>
                    <Address light={true} dense={true}/>
                    <SocialLinks inverted={dark_mode} dense={true}/>
                </Stack>
                <Sponsors/>
                <Copyright/>
            </Layout>
        </Box>
    );
}

export default Footer;
